var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayContinue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:#fff;}.c{fill:#304785;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308 -895)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.97,11.006l-9.19,5.332A1.183,1.183,0,0,1,4,15.331V4.667A1.182,1.182,0,0,1,5.781,3.662l9.19,5.332a1.158,1.158,0,0,1,0,2.012Z",
    transform: "translate(325 910.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayContinue);
export default __webpack_public_path__ + "static/media/play_continue.e3fe3be6be04d6faab14aa3d8ed98133.svg";
export { ForwardRef as ReactComponent };